
import FiltroPeriodo from "./FiltroPeriodo.vue";

export default {
  name: "MargemLucro",
  components: { FiltroPeriodo },
  props: {
    // objeto da margem (ex.: { margemPercent: 40, lucro: 100 })
    margemLucro: { type: [Object, Number, String], default: () => ({}) },

    // período atual (opcional): { inicio: 'YYYY-MM-DD', fim: 'YYYY-MM-DD' } ou null
    periodo: { type: Object, default: null },

    // estado de carregamento
    loading: { type: Boolean, default: false },

    // se true, NÃO dispara apply no mount do filtro (mantém quieto no boot)
    ignoreInitialApply: { type: Boolean, default: true },

    // opcional: mensagem de erro (se quiser exibir algo custom)
    error: { type: String, default: null },
  },
  data() {
    return {
      indicadorSelecionado: "margem",
    };
  },
  computed: {
    indicadorSelecionadoLabel() {
      return this.indicadorSelecionado === "margem"
        ? "Margem de lucro"
        : "Lucro";
    },
    margemNumber() {
      return this.toNumber(
        this.margemLucro?.margemPercent ??
          this.margemLucro?.margemPercentual ??
          this.margemLucro?.percentualLucro ??
          this.margemLucro?.percentual_lucro ??
          this.margemLucro?.margemLucro ??
          this.margemLucro?.margem_lucro ??
          this.margemLucro?.margem ??
          this.margemLucro ??
          0
      );
    },
    lucroNumber() {
      return this.toNumber(
        this.margemLucro?.lucro ??
          this.margemLucro?.lucroTotal ??
          this.margemLucro?.lucro_total ??
          this.margemLucro?.valorLucro ??
          this.margemLucro?.valor_lucro ??
          this.margemLucro?.totalLucro ??
          this.margemLucro?.total_lucro ??
          this.margemLucro?.lucroReais ??
          this.margemLucro?.lucro_reais ??
          0
      );
    },
  },
  methods: {
    onApplyPeriodo({ inicio, fim }) {
      // repassa para o pai exatamente como o TicketMedio faz
      this.$emit("change-periodo", { inicio, fim });
    },
    toNumber(value) {
      if (value === null || value === undefined || value === "") return 0;

      if (typeof value === "string") {
        const normalized = value.includes(",")
          ? value.replace(/\./g, "").replace(",", ".")
          : value;
        const n = Number(normalized);
        return Number.isFinite(n) ? n : 0;
      }

      const n = Number(value);
      return Number.isFinite(n) ? n : 0;
    },
    formatPercent(v) {
      if (v === null || v === undefined || v === "") return "0%";
      return `${String(v).replace(".", ",")}%`;
    },
    formatCurrency(v) {
      try {
        return new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
        }).format(v ?? 0);
      } catch {
        const num = Number(v ?? 0)
          .toFixed(2)
          .replace(".", ",");
        return `R$ ${num}`;
      }
    },
  },
};
